<template>
  <div>

    <v-card width="100%" v-if="current">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-9 col-sm-1">
                <v-text-field label="Nome" v-model="current.name" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
                <v-text-field label="Código" v-model="current.code" outlined dense disabled></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
    </v-card>

    <v-tabs v-model="tab" grow class="mt-2">
        <v-tab key="ot">
            ONT
        </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
        <v-tab-item key="ot">
            <v-row>
                <v-col cols="12" sm="6">
                    <v-btn color="primary" @click="ontSync()" class="ma-2" v-if="$auth.check('ROLE_ADMIN')">Sincronizar ONTs</v-btn>
                    <v-btn color="primary" @click="ontDiscovery()" class="ma-2" v-if="$auth.check('ROLE_ADMIN')">Descobrir ONTs</v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-alert dense text type="info" class="ma-2">
                    {{ counter }} registros encontrados
                    </v-alert>
                </v-col>
            </v-row>
            <v-card flat>
                <v-card-text>
                    <v-simple-table v-if="onts">
                        <thead>
                            <tr>
                            <th>Porta</th>
                            <th>ONTID</th>
                            <th>Serial</th>
                            <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in onts" :key="item.id">
                            <td>{{ item.port }}</td>
                            <td>{{ item.ontid }}</td>
                            <td>{{ item.serial }}</td>
                            <td>
                                <v-btn small color="primary" @click="ontInfo(item)">info</v-btn>&nbsp;
                                <v-btn small color="warning" @click="ontOptical(item)">optical</v-btn>&nbsp;
                                <v-btn small color="secondary" @click="ontPower(item)">power</v-btn>
                            </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
            </v-card>
        </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="dialog_discovery" max-width="500px">
        <v-card>
            <v-card-title>ONT - Discovery</v-card-title>
            <v-card-text>
                <v-simple-table v-if="discovery">
                        <thead>
                            <tr>
                            <th>Porta</th>
                            <th>Serial</th>
                            <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in discovery" :key="item.id">
                            <td>{{ item.port }}</td>
                            <td>{{ item.serial }}</td>
                            <td><v-btn color="success" @click="ontSetupDialog(item)">setup</v-btn></td>
                            </tr>
                        </tbody>
                </v-simple-table>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_ont_setup" max-width="500px" v-if="current_ont">
        <v-card>
            <v-card-title>ONT - Setup</v-card-title>
            <v-card-text>
                <div class="col-md-9 col-sm-1">
                    <v-text-field label="Frame" v-model="current_ont.frame" outlined dense disabled></v-text-field>
                    <v-text-field label="Slot" v-model="current_ont.slot" outlined dense disabled></v-text-field>
                    <v-text-field label="Port" v-model="current_ont.port" outlined dense disabled></v-text-field>
                    <v-text-field label="Serial" v-model="current_ont.serial" outlined dense disabled></v-text-field>
                    <v-text-field label="User VLAN" v-model="current_ont.uvlan" outlined dense></v-text-field>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn color="success" @click="ontSetup()">Ativar</v-btn>
                <v-btn color="default" @click="dialog_ont_setup = false">Cancelar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_ont_optical" max-width="700px" v-if="current_optical">
        <v-card>
            <v-card-title>ONT - Optical</v-card-title>
            <v-card-text>
                <div class="col-md-9 col-sm-1">
                    <pre>{{ current_optical }}</pre>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="dialog_ont_optical = false">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_ont_info" max-width="700px" v-if="current_info">
        <v-card>
            <v-card-title>ONT - Info</v-card-title>
            <v-card-text>
                <div class="col-md-9 col-sm-1">
                    <pre>{{ current_info }}</pre>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="dialog_ont_info = false">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_ont_power" max-width="700px" v-if="current_power">
        <v-card>
            <v-card-title>ONT - Power</v-card-title>
            <v-card-text>
                <v-simple-table v-if="discovery">
                        <thead>
                            <tr>
                            <th>Serial</th>
                            <th>Power</th>
                            <th>Horário</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in current_power" :key="item.id">
                            <td>{{ item.serial }}</td>
                            <td>{{ item.power }}</td>
                            <td>{{ item.time }}</td>
                            </tr>
                        </tbody>
                </v-simple-table>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="dialog_ont_power = false">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import api from "../../api/index.js";
export default {
    data: () => ({
        current: null,
        counter: 0,
        current_ont: null,
        current_optical: null,
        current_info: null,
        current_power: [],
        onts: [],
        discovery: [],
        tab: null,
        dialog_discovery: false,
        dialog_ont_setup: false,
        dialog_ont_optical: false,
        dialog_ont_info: false,
        dialog_ont_power: false,
        dialog_loading: false
    }),
    created: function() {
      this.load();
      this.loadONTs();
    },
    methods: {
      load: function() {
        var me = this;
        var token = localStorage.getItem("token");
        api
            .get("/olt/" + this.$route.params.id, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.current = response.data;
            })
            .catch(function(error) {
                console.log(error);
            });
      },
      loadONTs: function(){
        var me = this;
        var token = localStorage.getItem("token");
        api
            .get("/ont/olt/" + this.$route.params.id, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.onts = response.data;
                me.counter = me.onts.length;
            })
            .catch(function(error) {
                console.log(error);
            });
      },
      ontDiscovery: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
            .get("/ont/discovery/" + this.current.id, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.dialog_loading = false;
                me.discovery = response.data;
                if(response.data.length==0){
                    alert("Nenhuma ONT encontrada!");
                }else{
                    me.dialog_discovery = true;
                }
            })
            .catch(function(error) {
                me.dialog_loading = false;
                alert("Falha ao descobrir ONT!");
                console.log(error);
            });
      },
      ontSync: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
            .post("/ont/sync/" + this.current.id, null, { headers: { Authorization: "Bearer " + token } })
            .then(function() {
                me.dialog_loading = false;
                alert("ONT sincronizadas com sucesso!");
                me.loadONTs();
            })
            .catch(function(error) {
                me.dialog_loading = false;
                alert("Falha ao sincronizar ONT!");
                console.log(error);
            });
      },
      ontSetupDialog: function(ont){
          this.current_ont = ont;
          this.current_ont.uvlan = 10;
          this.dialog_ont_setup = true;
      },
      ontSetup: function(){
        var me = this;
        var token = localStorage.getItem("token");
        var uvlan = this.current_ont.uvlan;
        me.dialog_loading = true;
        api
            .post("/ont/setup/"+uvlan, this.current_ont, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.dialog_loading = false;
                alert("ONT Setup executado com sucesso!");
                me.dialog_ont_setup = false;
                me.current_ont = response.data;
                me.current_ont.uvlan = uvlan;
                me.current_ont.svlan = uvlan;
                me.discovery = [];
                me.dialog_sp_setup = true;
            })
            .catch(function(error) {
                me.dialog_loading = false;
                alert("Falha no ONT setup!");
                console.log(error);
            });
      },
      ontInfo: function(item){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
            .get("/ont/info/" + item.id, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.dialog_loading = false;
                me.current_info  = response.data;
                me.dialog_ont_info = true;
            })
            .catch(function(error) {
                me.dialog_loading = false;
                alert("Falha ao recuperar ont info!");
                console.log(error);
            });
      },
      ontOptical: function(item){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
            .get("/ont/optical/" + item.id, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.dialog_loading = false;
                me.current_optical  = response.data;
                me.dialog_ont_optical = true;
            })
            .catch(function(error) {
                me.dialog_loading = false;
                alert("Falha ao recuperar ont optical!");
                console.log(error);
            });
      },
      ontPower: function(item){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
            .get("/ont/power/" + item.serial, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.dialog_loading = false;
                me.current_power  = response.data;
                me.dialog_ont_power = true;
            })
            .catch(function(error) {
                me.dialog_loading = false;
                alert("Falha ao recuperar ont power!");
                console.log(error);
            });
      }
    }
}
</script>